import { render, staticRenderFns } from "./layNav.vue?vue&type=template&id=66fb1fe5"
import script from "./layNav.vue?vue&type=script&setup=true&lang=js"
export * from "./layNav.vue?vue&type=script&setup=true&lang=js"
import style0 from "./layNav.vue?vue&type=style&index=0&id=66fb1fe5&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports